import { Globe } from 'lucide-react'
import { Select } from '@radix-ui/themes'
import { useTranslation } from 'react-i18next'
import { LANGUAGE_OPTIONS } from '@/config/languages'

const LanguageSelector = ({ className = '' }: { className?: string }) => {
  const { t, i18n } = useTranslation()

  const selectedLanguage =
    LANGUAGE_OPTIONS.find((language) =>
      i18n.language.toLowerCase().startsWith(language.code)
    )?.code ?? 'en'

  return (
    <Select.Root
      value={selectedLanguage}
      onValueChange={(val) => i18n.changeLanguage(val)}
      size={{ initial: '3', lg: '2' }}
    >
      <Select.Trigger
        radius="full"
        variant="soft"
        color="amber"
        className={className}
        aria-label={t('settings.language')}
      >
        <div className="flex items-center gap-2 px-1">
          <Globe className="w-4 h-4" />
          <p className="font-semibold">
            {LANGUAGE_OPTIONS.find((l) => l.code === selectedLanguage)?.label}
          </p>
        </div>
      </Select.Trigger>
      <Select.Content color="amber">
        {LANGUAGE_OPTIONS.map((language) => (
          <Select.Item key={language.code} value={language.code}>
            {language.label}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  )
}

export default LanguageSelector
